import React, { useState } from "react";
// أو لو داخل src/assets:
import reg1 from "../assets/image/سجل1.png";
import reg2 from "../assets/image/سجل2.png";
export default function TradeRegister() {
  return (
    <div className="container py-5" dir="rtl">
      <h1 className="h4 mb-3 text-center">السجل التجاري</h1>
      <p className="text-muted text-center mb-4">
        هنا نسخ واضحة من السجل التجاري لجهة “التنظيم” — للاطّلاع والتوثيق.
      </p>

      {/* الصور */}
      <div className="d-flex flex-column align-items-center gap-4">
        <img
          src={reg1}
          alt="السجل التجاري - نسخة 1"
          className="img-fluid shadow-sm"
          style={{ border: "none", maxWidth: "100%" }}
        />
        <img
          src={reg2}
          alt="السجل التجاري - نسخة 2"
          className="img-fluid shadow-sm"
          style={{ border: "none", maxWidth: "100%" }}
        />
      </div>
    </div>
  );
}